'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('mail-template-edit', {
      url: '/admin/mail-template/edit/:id',
      template: '<mail-template-edit></mail-template-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/messaging/mail/template/edit/mail-template-edit.routes.js